import { createContext } from 'react';
export const WidthsStoreContext = /*#__PURE__*/createContext(undefined);